<template>
  <div class="flex items-center justify-between pb-4 pl-6 pt-[22px]">
    <div class="font-serif font-black leading-6 text-white">Settings</div>
  </div>
  <div v-for="item in listItems" :key="item.name" class="mb-4 px-4">
    <div class="px-2 py-1 text-[0.5625rem] font-extrabold leading-5 tracking-[2px] text-tint-400">
      {{ item.name }}
    </div>
    <div class="flex flex-col gap-px">
      <router-link
        v-for="child in item.children"
        :key="child.name"
        :to="child.route"
        activeClass="router-link-active bg-shade-840 font-bold text-white"
        class="items flex rounded-md transition-colors [&:not(.router-link-active)]:text-tint-80 [&:not(.router-link-active)]:hover:bg-shade-840/50 [&:not(.router-link-active)]:hover:text-white"
      >
        <div class="px-2 py-1.5 text-sm leading-5">{{ child.name }}</div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { EmployerFeatureService } from '@/core/shared/employer-feature/employer-feature.service';

const employerFeatureService = new EmployerFeatureService();

const listItems = computed(() => [
  {
    name: 'COMPANY',
    children: [
      { name: 'Company Overview', route: '/settings/company' },
      { name: 'Members', route: '/settings/members' },
      { name: 'Permissions', route: '/settings/permissions' },
    ],
  },
  {
    name: 'MY ACCOUNT',
    children: [
      { name: 'Profile', route: '/settings/profile' },
      { name: 'Notifications', route: '/settings/notifications' },
      { name: 'Security', route: '/settings/sign-in' },
      ...(employerFeatureService.hasMcpConnectorEnabled
        ? [{ name: 'AI assistants', route: '/settings/ai-assistants' }]
        : []),
    ],
  },
]);
</script>

<style scoped></style>
